// extracted by mini-css-extract-plugin
export default {"media-page":"Media_media-page__Gwi+o","main-media-title":"Media_main-media-title__Z7QTQ","video-responsive":"Media_video-responsive__58xS0"};